module.exports = __webpack_public_path__ + "static/carousel-hero-lite-2x-8198e451db1fbec0a1d6904a8ed8fb9b.png";